/**
 * @description 导出默认网路配置
 **/
const network = {
  // 设备类型
  deviceType: "web",
  // /配后端数据的接收方式application/json;charset=UTF-8或者application/x-www-form-urlencoded;charset=UTF-8
  contentType: "application/json;charset=UTF-8",
  //消息框消失时间
  messageDuration: 2000,
  //最长请求时间 3min
  requestTimeout: 1000 * 60 * 3,
  //操作正常code，支持String、Array、int多种类型
  successCode: [200, 0],
  //登录失效code
  invalidCode: 10001,
  //无权限code
  noPermissionCode: 401,
};
module.exports = network;
